/**
 * Custom Alert — Replaces browser's ugly `alert()` with a professional modal.
 *
 * Monkey-patches `window.alert` so ALL existing `alert()` calls
 * automatically use the custom modal. Zero code changes needed elsewhere.
 */

let alertContainer: HTMLDivElement | null = null;

function ensureContainer() {
  if (alertContainer && document.body.contains(alertContainer)) return alertContainer;
  alertContainer = document.createElement('div');
  alertContainer.id = 'custom-alert-root';
  document.body.appendChild(alertContainer);
  return alertContainer;
}

function showCustomAlert(message: string): void {
  const container = ensureContainer();

  const overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.4);backdrop-filter:blur(1px);';

  const modal = document.createElement('div');
  modal.style.cssText = 'background:white;border-radius:6px;box-shadow:0 12px 40px rgba(0,0,0,0.2);border:1px solid #e2e8f0;width:360px;max-width:90vw;overflow:hidden;animation:alertIn 0.15s ease-out;';

  // Header
  const header = document.createElement('div');
  header.style.cssText = 'background:#1e8585;padding:10px 16px;display:flex;align-items:center;gap:8px;';
  header.innerHTML = '<span style="color:white;font-size:14px;">⚠</span><span style="color:white;font-weight:700;font-size:13px;letter-spacing:0.5px;">Aarthika Pro</span>';

  // Body
  const body = document.createElement('div');
  body.style.cssText = 'padding:20px 24px;';
  const msgEl = document.createElement('p');
  msgEl.style.cssText = 'color:#334155;font-size:13px;line-height:1.6;margin:0;font-family:Inter,system-ui,sans-serif;';
  msgEl.textContent = message;
  body.appendChild(msgEl);

  // Footer
  const footer = document.createElement('div');
  footer.style.cssText = 'display:flex;justify-content:flex-end;padding:0 24px 20px;';
  const okBtn = document.createElement('button');
  okBtn.textContent = 'OK';
  okBtn.style.cssText = 'background:#1e8585;color:white;border:none;padding:7px 28px;border-radius:4px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;';
  okBtn.onmouseover = () => { okBtn.style.background = '#166e6e'; };
  okBtn.onmouseout = () => { okBtn.style.background = '#1e8585'; };

  const close = () => {
    overlay.style.opacity = '0';
    setTimeout(() => { container.removeChild(overlay); }, 100);
  };

  okBtn.onclick = close;
  overlay.onclick = (e) => { if (e.target === overlay) close(); };

  footer.appendChild(okBtn);
  modal.appendChild(header);
  modal.appendChild(body);
  modal.appendChild(footer);
  overlay.appendChild(modal);
  container.appendChild(overlay);

  // Focus OK button
  setTimeout(() => okBtn.focus(), 50);

  // Keyboard
  const keyHandler = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      e.preventDefault();
      e.stopImmediatePropagation();
      close();
      window.removeEventListener('keydown', keyHandler, true);
    }
  };
  window.addEventListener('keydown', keyHandler, true);

  // Add animation keyframes if not already added
  if (!document.getElementById('custom-alert-styles')) {
    const style = document.createElement('style');
    style.id = 'custom-alert-styles';
    style.textContent = '@keyframes alertIn { from { opacity:0; transform:scale(0.95) translateY(-8px); } to { opacity:1; transform:scale(1) translateY(0); } }';
    document.head.appendChild(style);
  }
}

export function initCustomAlert(): void {
  window.alert = showCustomAlert;
}
